module.exports = "<div style=display:none> <input style=box-sizing:border-box type=hidden value={{value}}> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/hidden-control/hidden-control.html
// module id = 1940
// module chunks = 50